import React from 'react';

import * as styles from './iframe-wrapper.module.scss';

interface IframeWrapperProps {
  children?: React.ReactNode;
}

export const IframeWrapper = ({ children }: IframeWrapperProps) => {
  return <span className={styles.IframeWrapper}>{children}</span>;
};

export default IframeWrapper;
